import { enums } from 'console-kit';

import RefData from 'ref-data';

export default {
  [RefData.Enum.STATUS.CAMPAIGNOBJECT.DRAFT]:     enums.colors.SUPER,
  [RefData.Enum.STATUS.CAMPAIGNOBJECT.READY]:     enums.colors.SUPER,
  [RefData.Enum.STATUS.CAMPAIGNOBJECT.SCHEDULED]: enums.colors.BASE,
  [RefData.Enum.STATUS.CAMPAIGNOBJECT.PUBLISHED]: enums.colors.ACTION,
  [RefData.Enum.STATUS.CAMPAIGNOBJECT.EXPIRED]:   enums.colors.ERROR,
  [RefData.Enum.STATUS.CAMPAIGNOBJECT.TEMPLATE]:  enums.colors.ADVANCED,
};
